/**
 * Created by scuzzort3 on 8/14/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditChildModalController', EditChildModalController);

    EditChildModalController.$inject = ['$modalInstance', '$scope', 'authentication', 'communityNode', '$modal'];

    function EditChildModalController($modalInstance, $scope, authentication, communityNode, $modal) {
        var vm = this;

        vm.isNewCommunityModal = true;
        vm.communityId = null;
        vm.originalParentId = null;
        vm.parentId = null;
        vm.parentName = "";
        vm.oldParentName = vm.parentName;
        vm.communityName = "";
        vm.isRegion = false;
        vm.isArchived = false;
        vm.hasChildren = false;
        vm.modalTitle = "Add New Community";
        vm.modalHelp = "Note: Changes to a community's region or directorate must be requested through IMCOM, and IMCOM must approve the change before the change can be made.";

        if (communityNode !== null) {
            vm.isNewCommunityModal = false;
            vm.modalHelp = "Making a region node inactive will cause all communities within that region to become inactive.";
            vm.modalTitle = "Edit Community - " + communityNode.value;
            vm.communityId = communityNode.id;
            vm.hasChildren = communityNode.children.length > 0;
            vm.isRegion = communityNode.isLeaf === 0;
            vm.isArchived = communityNode.isArchived === 1;
            vm.communityName = communityNode.value;
            if (communityNode.parent !== null) {
                vm.parentName = communityNode.parent.value;
                vm.parentId = communityNode.parent.id;
                vm.originalParentId = vm.parentId;
                vm.oldParentId = communityNode.parent.id;
                vm.oldParentName = communityNode.parent.value;
            }
        }
        else {
            vm.showHierarchy = true;
        }

        vm.enableSave = false;
        vm.parentIsArchived = false;

        if (communityNode !== null && vm.parentId !== null && communityNode.parent.isArchived === 1) {
            vm.isArchived = true;
            vm.parentIsArchived = true;
        }

        updateInactive();

        if (vm.hasChildren === true) {
            vm.isRegion = true;
        }

        vm.okEnabled = false;
        vm.onCancel = onCancel;
        vm.onSubmit = onSubmit;
        vm.onCommunityClicked = onCommunityClicked;
        vm.onCommunityCancelled = onCommunityCancelled;
        vm.checkCanSave = checkCanSave;

        function updateInactive() {
            vm.disableInactive = (vm.parentId === null && vm.communityId !== null) || vm.parentIsArchived;
        }

        function onCommunityClicked(clickedNode) {
            vm.parentId = clickedNode.id;
            vm.parentName = clickedNode.value;

            vm.oldParentName = clickedNode.value;
            vm.originalParentId = clickedNode.id;

            vm.showHierarchy = false;

            if (clickedNode.isArchived === 1) {
                vm.isArchived = true;
                vm.parentIsArchived = true;
            }
            else {
                vm.parentIsArchived = false;
            }

            updateInactive();

            vm.checkCanSave();
        }

        function onCommunityCancelled() {
            vm.showHierarchy = false;

            vm.parentId = vm.originalParentId;
            vm.parentName = vm.oldParentName;
        }

        function checkCanSave() {
            vm.enableSave = vm.communityName.length > 0 && vm.parentId !== null;
        }

        function displayError(error) {
            vm.formError = error;
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }

        function onSubmit() {
            var isLeafVal = 1;
            if (vm.isRegion === true) {
                isLeafVal = 0;
            }

            var isArchivedVal = 0;
            if (vm.isArchived === true) {
                isArchivedVal = 1;
            }

            var data = {
                id: vm.communityId,
                isArchived: isArchivedVal,
                name: vm.communityName,
                isLeaf: isLeafVal,
                communityParentId: vm.parentId};

            if (vm.isNewCommunityModal === true) {
                authentication.addCommunityInTree(data)
                    .then(function (result) {
                        $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                    })
                    .catch(displayError);
            }
            else {
                if (!communityNode.isArchived && data.isArchived) {
                    var modalInstance = $modal.open({
                        templateUrl: 'app/components/hierarchy/confirmCommunityInactive.template.html',
                        controller: 'ConfirmCommunityInactiveController',
                        controllerAs: 'vm',
                        resolve: {
                            community: function () {
                                return vm.communityName;
                            },
                            title: function () {
                                return "Inactivate Community";
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        return authentication.changeCommunityInTree(data)
                            .then(function (result) {
                                $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                                // TODO: Move this VMIS-specific functionality elsewhere
                                /*
                                return authentication.inactivateCommunity({communityAffiliationId: vm.communityId})
                                    .then(function (result){
                                        $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                                    });
                                */
                            })
                            .catch(displayError);
                    });
                }

                else {
                    authentication.changeCommunityInTree(data)
                        .then(function (result) {
                            $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                        })
                        .catch(displayError);
                }
            }
        }
    }
})();